import { useEffect, useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { AiOutlineDelete } from 'react-icons/ai';
import { BsListTask } from 'react-icons/bs';
import { FaEye, FaPlus, FaRegEdit } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import SubmitBtn from '../../../../Components/Buttons/SubmitBtn';
import ReactTable from '../../../../Components/ReactTable/ReactTable';
import {
  clearTable,
  createTableData,
  deleteTableData,
  editTableData,
  handleOfficeKindListChange
} from '../../../../Redux/slices/table';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../_helpers/_methods';
import SingleFormInput from '../components/SingleFormInput';

function OfficeKind() {
  const { id, edit: isEdit } = useParams();
  const dispatch = useDispatch();
  // const local = useSelector((state) => state.local.local);
  const results = useSelector((state) => state.table.results);
  const [office_kind, setOfficeKind] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const columns = useMemo(
    () => [
      { Header: <FormattedMessage id="sn" />, accessor: 'serial_number' },
      {
        Header: <FormattedMessage id="title" />,
        accessor: 'title'
      },

      {
        Header: <FormattedMessage id="actions" />,
        accessor: 'actions'
      }
    ],
    []
  );

  const ShowForm = (check) => {
    if (isEdit) {
      setOfficeKind(false);

      navigate('/admin/settings/office_kind/');
    } else {
      setValue('title', '');
      check = !check;
      check ? setOfficeKind(true) : setOfficeKind(false);
    }
  };
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({ mode: 'onBlur', defaultValues: {} });

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      if (office_kind && !isEdit) {
        let response = await fetchWrapper.post('/office-type/', data);
        dispatch(createTableData(response.data));
        toast.success(<FormattedMessage id="office_kind_created" />);

        setIsLoading(false);
        setOfficeKind(false);
        navigate('/admin/settings/office_kind/');
      }
      if (isEdit) {
        let response = await fetchWrapper.patch(`/office-type/${id}/`, data);
        dispatch(editTableData(response.data));
        toast.success(<FormattedMessage id="office_kind_updated" />);

        setIsLoading(false);
        setOfficeKind(false);

        navigate('/admin/settings/office_kind/');
      }
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };

  const navigate = useNavigate();
  const handleEdit = (id) => {
    ShowForm(isEdit);
    navigate({ pathname: `${`/admin/settings/office_kind/${id}/edit`}` });
  };

  const handleDelete = async (id) => {
    try {
      await fetchWrapper.delete(`/office-type/${id}/`);
      toast.success(<FormattedMessage id="office_kind_deleted" />);
      dispatch(deleteTableData(id));
      navigate('/admin/settings/office_kind/');
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };
  const data = useMemo(() => {
    if (!results) {
      return [];
    }

    let count = 1;
    return results.map((result) => {
      let action = (
        <div className="d-flex">
          <div>
            <Button variant="outline-info">
              <FaEye />
            </Button>
          </div>
          <div className="mx-2">
            <Button variant="outline-secondary" onClick={() => handleEdit(result.id)}>
              <FaRegEdit />
            </Button>
          </div>
          <div className='"mx-2'>
            <Button variant="outline-danger " onClick={() => handleDelete(result.id)}>
              <AiOutlineDelete />
            </Button>
          </div>
        </div>
      );
      return {
        serial_number: count++,
        title: result.title,
        actions: action
      };
    });
  }, [results]);

  const handleOfficeKindFetch = ({ index, pageSize }) => {
    dispatch(handleOfficeKindListChange({ index: index, pageSize: pageSize }));
  };
  useEffect(() => {
    return () => {
      dispatch(clearTable());
    };
  }, []);
  return (
    <div className="card content-section p-3">
      <div className=" d-flex justify-content-between align-items-end">
        <h4 className="d-inline-block text-primary">
          <BsListTask size={30} className="me-3" />
          <FormattedMessage id="office_type" className="" />
        </h4>
        <div className="d-flex justify-content-between align-items-end">
          <Button variant="primary" onClick={() => ShowForm(office_kind)} disabled={office_kind}>
            <FaPlus size={18} />
            <FormattedMessage id="add_new" />
          </Button>
        </div>
      </div>
      <hr />

      <div>
        {(isEdit || office_kind) && (
          <>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="ps-3">
                <SingleFormInput
                  inputType="text"
                  register={register}
                  title="office_type"
                  id={id}
                  type="office-type"
                  errors={errors}
                  isEdit={isEdit}
                  setValue={setValue}
                />{' '}
                <div className="d-flex mt-3">
                  <Button
                    variant="danger"
                    onClick={() => {
                      ShowForm(office_kind);
                    }}>
                    <FormattedMessage id="button.cancel" />
                  </Button>
                  <SubmitBtn
                    isLoading={isLoading}
                    buttonText={<FormattedMessage id="button.save" />}
                    icon="none"
                  />
                </div>
              </div>
            </form>
          </>
        )}
      </div>
      <div className="">
        <ReactTable data={data} columns={columns} dataFetcher={handleOfficeKindFetch} />
      </div>
    </div>
  );
}

export default OfficeKind;
